import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetcher } from '~lib/api/fetch';
import { COMPANYS_SOURCE_VALUE, WIKI_CATEGORY_KEY, WIKI_CATEGORY_TITLE } from '~types/company';

import QueryKeys from '../queryKeys';

const url = (companyId: string) => `/api/company/${companyId}/salariesByCategories`;

export type WikiSalaryChartResponse = {
  [key in WIKI_CATEGORY_KEY]: {
    min: number;
    max: number;
    avg: number;
    CORP: number;
    KJ: number;
    _sum: number;
    _cnt: number;
  };
};
export default function useGetWikiSalaryChart(
  companyId: string,
  isSalaryBlocked: boolean,
  selectSource: COMPANYS_SOURCE_VALUE,
) {
  const query = useQuery<WikiSalaryChartResponse, AxiosError>(
    [QueryKeys.companyWikiSalary, companyId],
    () => fetcher(url(companyId)),
    {
      enabled: !isSalaryBlocked,
    },
  );

  const transformedWitkSalary = transformWikiSalary(selectSource, query?.data);

  return {
    ...query,
    transformedWitkSalary,
  };
}

function transformWikiSalary(selectSource: COMPANYS_SOURCE_VALUE, data?: WikiSalaryChartResponse) {
  if (!data) {
    return [];
  }

  const juniorKey: WIKI_CATEGORY_KEY[] = ['HIGHSCHOOL', 'COLLEGE', 'UNIVERSITY', 'MASTER'];
  const seniorKey: WIKI_CATEGORY_KEY[] = ['JIDR', 'GJ', 'CJ', 'BJ'];

  return [juniorKey, seniorKey].map((keys) => {
    return keys.map((key) => {
      const avg = data[key][selectSource === '기업 제공' ? 'CORP' : 'avg'] ?? 0;
      const count = data[key]._cnt;

      return {
        title: WIKI_CATEGORY_TITLE[key],
        data: avg,
        stakeData: { min: data[key].min ?? 0, max: data[key].max ?? 0 },
        showData: {
          avg: avg >= 10000 ? 10000 : avg,
          min: data[key].min >= 10000 ? 10000 : data[key].min,
          max: data[key].max >= 10000 ? 10000 : data[key].max,
          count,
        },
        isDataEmpty: !Boolean(avg) && (count === 1 || !Boolean(count)),
      };
    });
  });
}
